<div class="sidebar">
	<app-sidebar-header [title]="this.title">
	</app-sidebar-header>
	<div #sidebar__body class="sidebar__body sl--scrollable">
		<app-flight-route [flight]="flight"></app-flight-route>
		<div id="service-added-warning-container" *ngIf="this.addedMesssage">
			<app-notification [style]="'alert'" [classes]="'alert-sidebar'" [title]="''"
				[icon]="'icons.svg#notification--warning'">
				<div message>
					<p>{{this.addedMesssage}}</p>
				</div>
			</app-notification>
		</div>

		<div class="sidebar__info--flight-info top-gap" *ngIf="!directFlight && stops.length && !flightBasedPack">
			<p>{{ 'whatsIncludedSidebars.text.thisTripHas' | ibeadmin: 'sync' }} {{stops.length}} {{ 'whatsIncludedSidebars.text.flights' | ibeadmin: 'sync' }}. {{ 'whatsIncludedSidebars.detailsPack.text.chooseForPackInfo' | ibeadmin: 'sync' }}</p>
			<app-segmented-control-radio 
				classes="sidebar__info--flight-info--options"
				(selected)="INDRA_selectedStop($event)"
				[_value]="selectedStop"
				[options]="stops">
			</app-segmented-control-radio>
		</div>

		<div #sidebar__info class="sidebar__info sidebar__info--columns">
			<div class="sidebar__info-text">
				<ul class="vantages-listing">
					<li>{{ INDRA_getInfoTranslation(1) | ibeadmin | async }}</li>
					<li>{{ INDRA_getInfoTranslation(2) | ibeadmin | async }}</li>
					<li>{{ INDRA_getInfoTranslation(3) | ibeadmin | async }}</li>
				</ul>
			</div>
		</div>
		<div *ngIf="this.showMeasure">
			<form [formGroup]="this.formDimension" role="alert" [attr.aria-label]="'ancillaries.bundlesSidebars.aria.measuresForm' | ibeadmin | async">
				<h4 class="title-h4">{{ INDRA_getTextTranslation('confirmToContinue') | ibeadmin: 'sync' }}</h4>
				<ng-container *ngIf="this.musicAncillary && this.musicAncillary.length">
					<app-checkbox-input formControlName="weightCheckInstrument" [id]="weightCheck" [parentForm]="this.formDimension" (change)="INDRA_resetSubmit()"
						label="{{ INDRA_getTextTranslationInstrument('confirmWeight') | ibeadmin: 'sync' }} {{ INDRA_getWeightLimit(this.musicAncillary)}}">
					</app-checkbox-input>
					<app-checkbox-input formControlName="sizeCheckInstrument" [id]="sizeCheck" [parentForm]="this.formDimension" (change)="INDRA_resetSubmit()"
						label="{{ INDRA_getTextTranslationInstrument('confirmDimension') | ibeadmin: 'sync' }}">
					</app-checkbox-input>
				</ng-container>

				<ng-container *ngIf="this.sportAncillary && this.sportAncillary.length">
					<app-checkbox-input formControlName="weightCheckSport" [id]="weightCheck" [parentForm]="this.formDimension" (change)="INDRA_resetSubmit()"
						label="{{ INDRA_getTextTranslationSports('confirmWeight') | ibeadmin: 'sync' }} {{ INDRA_getWeightLimit(this.sportAncillary)}}">
					</app-checkbox-input>
					<app-checkbox-input formControlName="sizeCheckSport" [id]="sizeCheck" [parentForm]="this.formDimension" (change)="INDRA_resetSubmit()"
						label="{{ INDRA_getTextTranslationSports('confirmDimension') | ibeadmin: 'sync' }} {{ INDRA_getDimensionLimit(this.sportAncillary) }}">
					</app-checkbox-input>
				</ng-container>
			</form>
			<span *ngIf=" this.submitted && this.INDRA_getErrorMessage()!= null" class="large-input__error">
				{{this.INDRA_getErrorMessage() | ibeadmin: 'sync' }}</span>
			<app-notification [style]="'note'" [classes]="'pack-sidebar'" [title]="''">
				<div message>
					<span>{{ INDRA_getTextTranslationInstrument('ifWeightIsHigherThan') | ibeadmin: 'sync' }} {{ INDRA_getHighestWeightLimit()}}{{ INDRA_getTextTranslationInstrument('contactCallCenter') | ibeadmin: 'sync' }}</span>
					<span class="bolder">{{'addMoreSidebars.general.texts.callCenterNumber' | ibeadmin:'sync'}}</span>
				</div>
			</app-notification>
		</div>
		<div class="flight">

			<div *ngIf="INDRA_isPackAvailable() && (INDRA_isPackEligibleOnSegment() || INDRA_hasActivePackOnSegment()); else packNotAvailable">
				<div class="passenger__details">
					<p class="bundle_total_info">
						{{ 'ancillaries.bundlesSidebars.totalPassengers' | ibeadmin | async }}:
						<span class="bold">{{INDRA_formatCash(selectedFeaturePrice)  | indracurrency:itemsCurrencyCode}}</span>
					</p>
				</div>
				<div class="sidebar__payment_totals" *ngIf="!INDRA_hasActivePackOnSegment(); else packIsActive">
					<div class="flow_actions">
						<button
							class="button"
							(click)="INDRA_addBundle()"
							[attr.aria-label]="'ancillaries.bundlesSidebars.aria.addBundle' | ibeadmin | async">
							{{ 'ancillaries.bundlesSidebars.addBundle' | ibeadmin | async }}
						</button>
					</div>
				</div>

				<ng-template #packIsActive>
					<button class="button button-secondary button--icon-right">
						{{ INDRA_printAddedButtonLabel() }}
						{{ INDRA_getTextTranslation("added") | ibeadmin : "sync" }}
						<app-svg
							aria-hidden="true"
							svg="icons.svg#general--check"
							[alt]="'Checked icon'"
						></app-svg>
					</button>
				</ng-template>
			</div>

			<ng-template #packNotAvailable>
				<div class="warning-banner">
				  <app-svg
					class="warning-icon"
					svg="icons.svg#general--information"
					aria-hidden="true"
					[alt]="'Warning icon'"
				  ></app-svg>
				  {{ INDRA_getTextTranslation("notAvailableFrom") | ibeadmin : "sync" }}
				  {{ INDRA_getLocation(flightStop.departureAirport) }}
				  {{ INDRA_getTextTranslation("to") | ibeadmin : "sync" }}
				  {{ INDRA_getLocation(flightStop.arrivalAirport) }}.
				</div>
			  </ng-template>

			<div class="sidebar-flight-text top-gap">
				<p>
					<li>{{ INDRA_getMainInfoTranslation() | ibeadmin | async }}</li>
				</p>
			</div>

			<div class="conditions">
				<h3 class="title-h3 conditions__title">{{ 'ancillaries.bundlesSidebars.conditions.title' | ibeadmin | async }}</h3>
				<div class="conditions__text">
					<div class="grid">
						<div class="col-12">
							<ul class="bullet-list">
								<li>{{ INDRA_getConditionTranslation(1) | ibeadmin | async }}</li>
								<li>{{ INDRA_getConditionTranslation(2) | ibeadmin | async }}</li>
								<li>{{ INDRA_getConditionTranslation(3) | ibeadmin | async }}</li>
								<li>{{ INDRA_getConditionTranslation(4) | ibeadmin | async }}</li>
							</ul>
						</div>
					</div>
				</div>
				<!-- <a class="link link--external" href="javascript:;">All terms and conditions</a> -->
			</div>
		</div>
		<div #sidebar__footer class="sidebar__footer">
		</div>
	</div>